import React, {useState} from 'react';
export default function useOpenSidebar(isDesktop) {
   const [openSidebar, setOpenSidebar] = useState(false);
   const [anchor, setAnchor] = useState(false);
   //const shouldOpenSidebar = isDesktop ? true : openSidebar;
   const shouldOpenSidebar = anchor && isDesktop ? anchor : openSidebar;

   function toggleSideBarOpen() {
      setOpenSidebar(!openSidebar);
      if (isDesktop) {
         setAnchor(!openSidebar);
      }
   }

   function handleSidebarOpen(e) {
      if (isDesktop && !anchor) {
         setOpenSidebar(true);
      } else {
         if (e.type !== 'mouseenter') {
            setOpenSidebar(true);
         }
      }
   }

   function handleSidebarClose(e) {
      if (isDesktop && !anchor) {
         setOpenSidebar(false);
      } else {
         if (e.type !== 'mouseleave') {
            setOpenSidebar(false);
         }
      }
   }
   return {
      anchor,
      openSidebar: shouldOpenSidebar,
      toggleSideBarOpen,
      handleSidebarOpen,
      handleSidebarClose
   };
}
